// src/lib/utils/index.js

import classNames from 'classnames';

export const cn = (...args) => classNames(args);